import { AppRoutes } from './routes';
import { AppCookieBanner } from './components/AppCookieBanner';

export function App() {
  return (
    <>
      <AppRoutes />
      <AppCookieBanner />
    </>
  );
}
